import { useQuery } from '@tanstack/react-query';
import { getPendingAccessorialInclusion, getUserInvoiceSettings, } from 'utils/UserServiceAPIUtils';
export function useShipperInvoiceConfig(shipperUserId) {
    return useQuery(['shipper-invoice-config', shipperUserId], async () => {
        var _a, _b, _c, _d;
        if (!shipperUserId) {
            return {};
        }
        const [settingsResp, includeResp] = await Promise.all([
            getUserInvoiceSettings(shipperUserId),
            getPendingAccessorialInclusion(shipperUserId),
        ]);
        const invoiceSetting = (_b = (_a = settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.data) === null || _a === void 0 ? void 0 : _a.getInvoiceSetting) === null || _b === void 0 ? void 0 : _b.invoice_setting;
        const includePending = (_d = (_c = includeResp === null || includeResp === void 0 ? void 0 : includeResp.data) === null || _c === void 0 ? void 0 : _c.getBillReadyStatusCalculation) === null || _d === void 0 ? void 0 : _d.include_pending_accessorials_in_calculation;
        return {
            invoiceGrouping: invoiceSetting === null || invoiceSetting === void 0 ? void 0 : invoiceSetting.invoice_grouping,
            includePendingAccessorials: includePending,
        };
    }, {
        enabled: Boolean(shipperUserId),
        staleTime: 30000,
    });
}
